
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin, getQueryString } from '@/common/ts/common';
import { vote } from '../api';
import SlideVerify from '@/components/SlideVerify.vue';
import qs from 'qs';

Vue.use(Popup).use(Dialog).use(Toast).use(Button);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop({ default: false }) voteWeChat!: boolean;
  @Prop({ default: 10 }) MaxNum!: number;
  @Prop({ default: false }) mustLogin!: boolean;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  SlideShow = false;
  pointOut = false;
  unionId!: string | null;
  voteing: boolean = false;
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  startVote() {
    if (this.voteing) {
      console.log('上次投票还在请求中');
      return;
    }
    // 判断是不是可以在微信中投票
    if (
      this.voteWeChat &&
      isWeiXin() &&
      !window.localStorage.getItem('unionid')
    ) {
      this.$dialog
        .confirm({
          title: '微信登录',
          message: '点赞前需要进行微信登录',
        })
        .then(() => {
          console.log('确定');
          this.WechatLogin();
        })
        .catch(() => {
          console.log('取消');
        });
      return;
    }
    // 开始投票，判断是不是必须在app内投票
    if (this.voteWeChat && isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        id: this.voteId,
        unionid: this.unionId,
      };

      this.voteing = true;

      vote(this.voteName, data).then((result: any) => this.successVote(result));
    } else if (window.udid) {
      // 在app内投票
      if (this.mustLogin) {
        const token = window.gettoken && window.gettoken();
        if (!token || token === 'null') {
          window.handleMessage('{"action":"mUserLogin","data":""}');
          return;
        }
      }
      this.voteing = true;
      const data = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
      };
      vote(this.voteName, data).then((result: any) => this.successVote(result));
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  fSlideData(res: object) {
    this.SlideShow = false;
    if (this.voteWeChat && isWeiXin()) {
      const data = {
        id: this.voteId,
        unionid: this.unionId,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    } else if (window.udid) {
      const data = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  successVote(res: any) {
    this.voteing = false;
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        this.$emit('votSuccess', res.data);
        break;
      case 201:
        this.SlideShow = true;
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;

      case 203:
        if (this.voteWeChat && isWeiXin()) {
          Dialog.confirm({
            title: '友情提示',
            message: `当日投票次数已用完，请前往上游新闻app查看`,
            confirmButtonText: '还没装？一步安装',
            cancelButtonText: '我已安装过',
            closeOnClickOverlay: true,
          })
            .then(() => {
              window.location.href = this.downLoadUrl;
            })
            .catch(() => {
              if (isWeiXin() === true) {
                this.pointOut = true;
              } else {
                window.location.href =
                  'shangyounews://{"dt":"7","url":"' +
                  document.location.href +
                  '"}';
              }
            });
        } else {
          Toast.fail(res.msg);
        }
        break;
      case 500:
      case 204:
      case 300:
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
